export default __webpack_public_path__ + "static/media/enghien01.a403a294.jpg";